import { render, staticRenderFns } from "./residence.vue?vue&type=template&id=16308348&scoped=true"
import script from "./residence.vue?vue&type=script&lang=ts"
export * from "./residence.vue?vue&type=script&lang=ts"
import style0 from "./residence.vue?vue&type=style&index=0&id=16308348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16308348",
  null
  
)

export default component.exports